import { FieldRenderProps } from '@progress/kendo-react-form'
import React, { useEffect, useMemo } from 'react'
import { TicketApi } from '../../../redux/api/TicketApi';
import { Button } from "@progress/kendo-react-buttons";
import { IStopwatch, StopwatchProps } from '../../../types/Ticket/IStopwatch';

const Stopwatch: React.FC<FieldRenderProps> = ({ action, ticketId, isBill, onStart, onStop, onTick }) => {

    const { data: stopwatches } = TicketApi.useGetStopwatchesQuery(ticketId)
    const [startStopwatch] = TicketApi.useStartStopwatchMutation()
    const [stopStopwatch] = TicketApi.useStopStopwatchMutation()
    const runningWatches = useMemo(() => stopwatches?.filter(s => s.Is_Bill === (isBill ? true : false) && s.IsTicking === true && (action?.ID || 0) === (s.Call_Action_Id || 0)), [stopwatches, isBill, action?.ID]);
    const isRunning = runningWatches?.length > 0;
    const title = `${isRunning ? 'Stop' : 'Start'} stopwatch`
    const [timer, setTimer] = React.useState<number>();

    function stopwatchClicked(e) {
        let props = { ActionId: action?.ID || undefined, TicketId: ticketId, IsBill: isBill ? true : false } as StopwatchProps
        if (isRunning)
            stopStopwatch(props).unwrap().then((data: IStopwatch) => {
                window.clearInterval(timer);
                setTimer(null);
                onStop && onStop(data);
            });
        else {
            if (!action || ((isBill && action.Billable_Time === 0) || (!isBill && action.Non_Billable_Time === 0)) || window.confirm('Starting the stopwatch will remove any existing time, are you sure you want to continue?')) {
                startStopwatch(props).unwrap().then((data: IStopwatch) => {
                    //console.log('More Cool!', data)
                    onStart && onStart(data);
                });
            }
        }
    }

    //Set a timer to keep the time up to date
    useEffect(() => {
        if (runningWatches?.length > 0) {
            let interval = window.setInterval(() => {
                if (runningWatches?.length > 0) {
                    onTick && onTick(runningWatches[0]);
                }
            }, 1000);
            onTick && onTick(runningWatches[0]);
            return () => { clearInterval(interval); }
        }
    }, [runningWatches, onTick])

    return (
        <>
            <Button title={title} onClick={stopwatchClicked} formNoValidate={true} type="button">
                {isRunning
                    ? <img alt='Stopwatch running' src='./images/stopwatch_on.gif' width={20} height={20} />
                    : <img alt='Stopwatch not running' src='./images/stopwatch_off.gif' width={20} height={20} />}
            </Button>
        </>
    )
}

export default Stopwatch;